export const dominationServicesArray = [
  { label: 'Online Domination Session (30 min)', price: '€50' },
  { label: 'Online Domination Session (60 min)', price: '€90' },
  { label: 'Custom Video (5 min)', price: '€60' },
  { label: 'Custom Video (10 min)', price: '€100' },
  { label: 'Exclusive Audio Message', price: '€40' },
  { label: 'Daily Control Package (per day)', price: '€75' },
];

export const findomServicesArray = [
  { label: 'Findom Obedience Task (per task)', price: '€25+' },
  { label: 'Money Drain Session (30 min)', price: 'Tribute Required' },
  { label: 'Pay-to-Text (per message)', price: '€10' },
  { label: 'Humiliation Payment', price: '€50+' },
  { label: 'Cash Drain (Custom Tribute)', price: 'Enquire' },
];

export const keyHoldingServicesArray = [
  { label: 'Key Holding (1 Week)', price: '€100' },
  { label: 'Key Holding (1 Month)', price: '€350' },
  { label: 'Key Release (with permission)', price: '€50' },
  { label: 'Denied Release (per request)', price: '€20' },
];

export const usedClothingArray = [
  { label: 'Worn Panties (24 hours)', price: '€100' },
  { label: 'Worn Stockings', price: '€80' },
  { label: 'Worn Lingerie Set', price: '€150' },
  { label: 'Well-Worn Heels', price: '€200' },
  { label: 'Signed & Scented Item', price: '€50+' },
];

export const customFetishPicturesArray = [
  { label: 'Custom Fetish Picture Collection (e.g., feet, etc.)', price: '€90' },
];

export const extrasArray = [
  { label: 'Priority Service Upgrade', price: '€20' },
  { label: 'Discreet Packaging (for physical items)', price: '€15' },
  { label: 'Personalized Handwritten Note', price: '€30' },
  { label: 'Extra Scent (upon request)', price: '€10' },
];
